import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AuthGuard } from './auth/AuthGuard';
import { AdminLayout } from './layouts/AdminLayout';
import { AuthLayout } from './layouts/AuthLayout';
import { LoginPage } from './pages/LoginPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { DashboardPage } from './pages/DashboardPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { PlaceholderPage } from './pages/PlaceholderPage';
import { UsersPage } from './pages/UsersPage';
import { AuditLogPage } from './pages/AuditLogPage';
import { CouponsPage } from './pages/CouponsPage';
import { TermsPage } from './pages/TermsPage';
import { AccountsFundedPage } from './pages/AccountsFundedPage';
import { AccountsTestingPage } from './pages/AccountsTestingPage';
import { ActivationsPage } from './pages/ActivationsPage';
import { PendingRestartsPage } from './pages/PendingRestartsPage';
import { FundedApprovalsPage } from './pages/FundedApprovalsPage';
import { ForexRenovationsPage } from './pages/ForexRenovationsPage';
import { TradersPage } from './pages/TradersPage';
import { TraderDossierPage } from './pages/TraderDossierPage';
import { PlansPage } from './pages/PlansPage';
import { TwoFactorSetupPage } from './pages/TwoFactorSetupPage';
import { ComunicadosPage } from './pages/ComunicadosPage';
import { ReferralsPage } from './pages/ReferralsPage';
import { ContractsPage } from './pages/ContractsPage';
import { PlatformsPage } from './pages/PlatformsPage';
import { ReplicatorsPage } from './pages/ReplicatorsPage';
import { CheckoutAddonsPage } from './pages/CheckoutAddonsPage';
import { CsvImportsPage } from './pages/CsvImportsPage';
import { WithdrawalsPage } from './pages/WithdrawalsPage';
import { AffiliatesPage } from './pages/AffiliatesPage';
import { DelinquenciesPage } from './pages/DelinquenciesPage';
import { SettingsPage } from './pages/SettingsPage';

export const router = createBrowserRouter([
  {
    element: <AuthLayout />,
    children: [
      { path: '/login', element: <LoginPage /> },
      { path: '/forgot-password', element: <ForgotPasswordPage /> },
      { path: '/reset-password', element: <ResetPasswordPage /> },
    ],
  },
  {
    element: <AuthGuard />,
    children: [
      // 2FA obrigatório: tela de enrolamento fora do AdminLayout (sem sidebar),
      // para o admin não conseguir navegar antes de habilitar o TOTP.
      { path: '/2fa-setup', element: <TwoFactorSetupPage /> },
      {
        element: <AdminLayout />,
        children: [
          { path: '/', element: <DashboardPage /> },
          { path: '/traders', element: <TradersPage /> },
          // Dossiê: sem :userId abre a busca por e-mail/CPF; com id, direto.
          { path: '/traders/dossie', element: <TraderDossierPage /> },
          { path: '/traders/:userId', element: <TraderDossierPage /> },
          // Contas Virtuais foi dividido em Funded + Testing
          { path: '/accounts', element: <Navigate to="/accounts/funded" replace /> },
          { path: '/accounts/funded', element: <AccountsFundedPage /> },
          { path: '/accounts/testing', element: <AccountsTestingPage /> },
          { path: '/activations', element: <ActivationsPage /> },
          { path: '/restarts', element: <PendingRestartsPage /> },
          { path: '/metas', element: <FundedApprovalsPage /> },
          { path: '/forex', element: <ForexRenovationsPage /> },
          // Rota antiga (fila de renovação Forex, descontinuada em jul/2026)
          { path: '/forex-renovations', element: <Navigate to="/forex" replace /> },
          { path: '/withdrawals', element: <WithdrawalsPage /> },
          { path: '/afiliados', element: <AffiliatesPage /> },
          { path: '/replicators', element: <ReplicatorsPage /> },
          { path: '/plans', element: <PlansPage /> },
          { path: '/coupons', element: <CouponsPage /> },
          { path: '/comunicados', element: <ComunicadosPage /> },
          { path: '/indicacoes', element: <ReferralsPage /> },
          { path: '/checkout-addons', element: <CheckoutAddonsPage /> },
          {
            path: '/subscriptions',
            element: <PlaceholderPage marker="M2.6" title="Assinaturas" />,
          },
          { path: '/contracts', element: <ContractsPage /> },
          { path: '/platforms', element: <PlatformsPage /> },
          { path: '/delinquencies', element: <DelinquenciesPage /> },
          { path: '/csv-imports', element: <CsvImportsPage /> },
          { path: '/documents', element: <PlaceholderPage marker="M1.10" title="Documentos" /> },
          { path: '/audit', element: <AuditLogPage /> },
          { path: '/users', element: <UsersPage /> },
          { path: '/settings', element: <SettingsPage /> },
          { path: '/terms', element: <TermsPage /> },
          { path: '/2fa', element: <Navigate to="/2fa-setup" replace /> },
          { path: '*', element: <NotFoundPage /> },
        ],
      },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);
